import { type UseQueryResult, useQuery } from 'react-query';
import { PsuAwardService } from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetPsuFileNameList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const { createdFromDate: fromDate, createdToDate: toDate } = tableInfo;
  const PSUFileNameList = useQuery(
    ['getPSUFileNameList', fromDate, toDate],
    async () => {
      return await handleRequest(
        PsuAwardService.getApiAwardApiAppPSUAwardPSUFileNameList(fromDate, toDate)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item ?? '',
            value: item ?? '',
          };
        });
      },
    }
  );

  return PSUFileNameList;
};

export default useGetPsuFileNameList;
